import { PUBLIC_IP_NSG_NOTE, PUBLIC_IP_QUESTION } from '@/data/publicIp'
import styles from './Infrastructure.module.css'
import { PublicIpQuotaNotice } from './PublicIpQuotaNotice'
import { YesNoQuestion } from './YesNoQuestion'

interface PublicIpQuestionProps {
  /** The radio group's name, unique on the page: `rds-public-ip` or `db-public-ip`. */
  name: string
  /** The answer. No until the user says Yes, so No is shown chosen. */
  value: boolean
  onChange: (publicIp: boolean) => void
  /** What the answer covers, for the RDS server (every RDS VM created together). Left out where there is nothing to add. */
  coverage?: string | null
}

/**
 * "Do you need a public IP for this server?" for a Dedicated server that is a VM (RdsServerSection and DbServerSection decide when it is
 * shown). A required Yes/No that starts at No. A Yes says what it exposes, who controls access, and (for the RDS server) how many public IPs
 * are created, and shows the quota notice when the subscription cannot give them.
 */
export function PublicIpQuestion({ name, value, onChange, coverage }: PublicIpQuestionProps) {
  return (
    <div data-testid={name} style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      <YesNoQuestion question={PUBLIC_IP_QUESTION} name={name} value={value} onChange={onChange} hint={value ? PUBLIC_IP_NSG_NOTE : undefined} />
      {coverage && (
        <p className={styles.note} data-testid={`${name}-coverage`}>
          {coverage}
        </p>
      )}
      {value && <PublicIpQuotaNotice />}
    </div>
  )
}
